

export const BaseUrl = 'https://admin.foodweb-macaw.ksoftpl.com/api';
export const AssetsUrl = 'https://admin.foodweb-macaw.ksoftpl.com'; 

global.BaseUrl = 'https://admin.foodweb-macaw.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-macaw.ksoftpl.com';


